<div [formGroup]="form" class="widget-chat" [style.--social-input-max-height.px]="maxEditorHeight">
<!--  <div class="p-inputgroup write-message">-->
<!--    <textarea-->
<!--      #chatInput-->
<!--      type="text"-->
<!--      pInputTextarea-->
<!--      [autoResize]="true"-->
<!--      [rows]="1"-->
<!--      [cols]="10"-->
<!--      class="input-single-row"-->
<!--      [placeholder]="label"-->
<!--      (keydown)="onKeydown($event, chatInput)"-->
<!--      (onResize)="onTextareaResize()"-->
<!--    ></textarea>-->
<!--    <div class="input-action-box input-action-box-flex">-->
<!--      <button pButton pRipple type="button" icon="pi pi-clock" (click)="op.toggle($event)"-->
<!--              class="p-button-text rounded-circle p-button-plain"></button>-->
<!--      <button pButton pRipple type="button" icon="pi pi-image" (click)="onMediaBoxOpen()"-->
<!--              class="p-button-text rounded-circle p-button-plain"></button>-->
<!--      <button pButton pRipple type="button" icon="pi pi-send" (click)="onInputSubmitClick(chatInput)"-->
<!--              [loading]="loading" [disabled]="form.invalid || loading || disabled"-->
<!--              class="p-button-text rounded-circle p-button-plain"></button>-->
<!--      <p-overlayPanel #op styleClass="emoji">-->
<!--        <ng-template pTemplate style="width: 600px">-->
<!--          <button *ngFor="let emoji of chatEmojis;" pButton pRipple-->
<!--                  (click)="op.hide(); onEmojiClick(chatInput, emoji)" type="button" [label]="emoji"-->
<!--                  class="emoji-button p-2 p-button-text p-button-plain"></button>-->
<!--        </ng-template>-->
<!--      </p-overlayPanel>-->
<!--    </div>-->
<!--    <div #preview-->
<!--         style="position: absolute; z-index: -1; padding-left: 0.75rem; top: 0; max-width: 100%; overflow: hidden; visibility: hidden">{{ form.get('content').value }}-->
<!--    </div>-->
<!--  </div>-->

  <div #parent class="relative p-inputgroup w-100 write-message">
    <tiptap-editor #tiptap [editor]="editor" (keydown)="onEditorKeydown($event)" (input)="onEditorInput()"></tiptap-editor>
    <div class="input-action-box input-action-box-flex">
      <button pButton pRipple type="button" icon="pi pi-face-smile" (click)="toggleEmojiPicker($event)"
              class="p-button-text rounded-circle p-button-plain"></button>
      <button pButton pRipple type="button" icon="pi pi-image" (click)="onMediaBoxOpen()"
              class="p-button-text rounded-circle p-button-plain"></button>
      <button pButton pRipple type="button" icon="pi pi-send" (click)="onInputSubmitClick()"
              [loading]="loading" [disabled]="isSubmitActionDisabled()"
              class="p-button-text rounded-circle p-button-plain"></button>
    </div>
    <div class="emoji-panel" *ngIf="showEmojiPicker" (click)="$event.stopPropagation()">
      <emoji-mart (emojiSelect)="selectEmoji($event?.emoji?.native || $event?.native || '')"></emoji-mart>
    </div>
    <div
      #mentionPanel
      *ngIf="isMentionPanelVisible"
      class="mention-panel-floating"
      [ngStyle]="mentionPanelStyle"
      (click)="$event.stopPropagation()">
      <div *ngIf="isMentionLoading" class="flex justify-content-center mention-panel-loader">
        <p-progressSpinner styleClass="mention-panel-loader__spinner" strokeWidth="4" animationDuration=".8s">
        </p-progressSpinner>
      </div>
      <div *ngIf="!isMentionLoading && !mentionItems.length" class="mention-panel-empty">No results</div>
      <div *ngIf="!isMentionLoading && mentionItems.length" class="mention-panel-list" [style.maxHeight.px]="scrollHeight">
        <div *ngIf="hashtagMentionDisplayItems.length" class="mention-panel-group">
          <div class="mention-panel-group__label">Tags</div>
          <button
            *ngFor="let item of hashtagMentionDisplayItems"
            type="button"
            pRipple
            class="mention-panel-item"
            (click)="selectItem(item)">
            <span class="mention-panel-item__text">{{ item.alias }}</span>
          </button>
        </div>
        <div *ngIf="userMentionDisplayItems.length" class="mention-panel-group">
          <div class="mention-panel-group__label">Users</div>
          <button
            *ngFor="let item of userMentionDisplayItems"
            type="button"
            pRipple
            class="mention-panel-item"
            (click)="selectItem(item)">
            <span class="mention-panel-item__media">
              <img *ngIf="item.thumbnail" [src]="item.thumbnail" [alt]="item.alias" class="mention-panel-item__avatar">
              <span *ngIf="!item.thumbnail" class="mention-panel-item__avatar mention-panel-item__avatar--fallback">
                {{ item.alias?.charAt(0) || '?' }}
              </span>
            </span>
            <span class="mention-panel-item__text">{{ item.alias }}</span>
          </button>
        </div>
        <div *ngIf="projectMentionDisplayItems.length" class="mention-panel-group">
          <div class="mention-panel-group__label">Projects</div>
          <button
            *ngFor="let item of projectMentionDisplayItems"
            type="button"
            pRipple
            class="mention-panel-item"
            (click)="selectItem(item)">
            <span class="mention-panel-item__media">
              <img *ngIf="item.thumbnail" [src]="item.thumbnail" [alt]="item.alias" class="mention-panel-item__avatar">
              <span *ngIf="!item.thumbnail" class="mention-panel-item__avatar mention-panel-item__avatar--fallback">
                {{ item.alias?.charAt(0) || '?' }}
              </span>
            </span>
            <span class="mention-panel-item__text">{{ item.alias }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="form.get('content').invalid && form.get('content').dirty" class="app-form-error">
    <p>{{ form.get('content')['errorMessage'] }}</p>
    <p *ngIf="form.get('content').errors?.custom">{{ form.get('content').errors?.custom }}</p>
  </div>
  <div *ngIf="disabled" class="pt-3">
    <p-progressBar [style]="{'height': '6px'}" [showValue]="false" [value]="mediaProgress"
                   [mode]="mediaProgress ? 'determinate' : 'indeterminate' "></p-progressBar>
  </div>
  <div class="pt-3" [hidden]="isMediaBoxHidden">
    <div class="chat-upload__previews" *ngIf="mediaObjectAMs.length || newFiles.length">
      <div class="chat-upload__preview-item" *ngFor="let media of mediaObjectAMs">
        <p-skeleton *ngIf="media.type === MediaTypeEnum.IMAGE && !isExistingMediaPreviewLoaded(media)"
          width="100%" height="100%"></p-skeleton>
        <img *ngIf="media.type === MediaTypeEnum.IMAGE" [src]="getExistingMediaPreviewUrl(media)" [alt]="media.originalName || media.name || ''"
          [class.chat-upload__preview-image--pending]="!isExistingMediaPreviewLoaded(media)"
          (load)="markExistingMediaPreviewLoaded(media)">
        <app-native-video-preview *ngIf="media.type === MediaTypeEnum.VIDEO"
          [fallbackSrc]="getExistingMediaPreviewUrl(media)"
          [enableSkeleton]="false" [clickToToggle]="true"></app-native-video-preview>
        <div *ngIf="media.type !== MediaTypeEnum.IMAGE && media.type !== MediaTypeEnum.VIDEO" class="chat-upload__file">
          <i class="pi pi-file"></i>
          <span>{{media.originalName || media.name}}</span>
        </div>
        <button pButton type="button" icon="pi pi-times" class="p-button-text p-button-plain p-button-rounded chat-upload__preview-remove"
          [attr.aria-label]="'common.remove' | translate" (click)="removeExistingMedia(media)"></button>
      </div>
      <div class="chat-upload__preview-item" *ngFor="let file of newFiles">
        <p-skeleton *ngIf="file.type.includes(MediaTypeEnum.IMAGE.toLowerCase()) && !isNewFilePreviewLoaded(file)"
          width="100%" height="100%"></p-skeleton>
        <img *ngIf="file.type.includes(MediaTypeEnum.IMAGE.toLowerCase())" [src]="file | sanitizeUrl" [alt]="file.name"
          [class.chat-upload__preview-image--pending]="!isNewFilePreviewLoaded(file)"
          (load)="markNewFilePreviewLoaded(file)">
        <app-native-video-preview *ngIf="file.type.includes(MediaTypeEnum.VIDEO.toLowerCase())"
          [fallbackFile]="file" [enableSkeleton]="false" [clickToToggle]="true"></app-native-video-preview>
        <div *ngIf="!file.type.includes(MediaTypeEnum.IMAGE.toLowerCase()) && !file.type.includes(MediaTypeEnum.VIDEO.toLowerCase())"
          class="chat-upload__file">
          <i class="pi pi-file"></i>
          <span>{{file.name}}</span>
        </div>
        <button pButton type="button" icon="pi pi-times" class="p-button-text p-button-plain p-button-rounded chat-upload__preview-remove"
          [attr.aria-label]="'common.remove' | translate" (click)="removeFile(file, $event)"></button>
      </div>
    </div>
    <p-fileUpload
      [styleClass]="'chat-upload'"
      customUpload="true"
      [previewWidth]="128"
      [multiple]="true"
      [auto]="true"
      (uploadHandler)="onFileSelect($event)"
      (onRemove)="onFileRemove($event)"
      [accept]="imageOnly ? '.png,.jpg,.jpeg,.webp,.gif' : (chatMode ? '.png,.jpg,.jpeg,.webp,.gif,.mp4,.mov,.pdf' : '.png,.jpg,.jpeg,.webp,.mp3,.mkv,.mp4,.mov')"
    ></p-fileUpload>
  </div>
</div>

<app-typing-indicator *ngIf="!chatMode" [channel]="typingChannel"></app-typing-indicator>
